export const features = [
  {
    icon: "ri-eye-line",
    title: "Video nadzor 4K",
    description: "Najnovije IP kamere sa 4K rezolucijom, AI detekcijom lica i vozila, noćnim vidom u boji i cloud arhiviranjem.",
  },
  {
    icon: "ri-door-lock-line",
    title: "Kontrola pristupa",
    description: "RFID kartice, biometrijski čitači i pametne brave. Potpuna kontrola nad tim ko, kada i gde ulazi.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Mobilna aplikacija",
    description: "Pratite svoj objekat 24/7 putem iOS i Android aplikacije. Push notifikacije, live view i daljinska kontrola.",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "Alarmni sistemi",
    description: "Bežični alarmni sistemi sa 20+ zona, GSM/4G backup komunikacijom i trenutnim obaveštenjima.",
  },
  {
    icon: "ri-cloud-line",
    title: "Cloud arhiviranje",
    description: "Sigurno čuvanje video snimaka u cloudu sa enkripcijom. Pristup sa bilo kog uređaja, bilo gde.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/7 Podrška",
    description: "Naš tim tehničke podrške dostupan je 24 časa dnevno, 7 dana u nedelji za sve vaše potrebe.",
  },
];

export const whyChooseUs = [
  {
    icon: "ri-shield-star-line",
    title: "Sertifikovana oprema",
    description: "Sva naša oprema poseduje CE, FCC i RoHS sertifikate i prolazi rigorozne testove kvaliteta.",
  },
  {
    icon: "ri-team-line",
    title: "Stručan tim",
    description: "Naš tim čini 50+ sertifikovanih inženjera sa dugogodišnjim iskustvom u bezbednosnim sistemima.",
  },
  {
    icon: "ri-tools-line",
    title: "Instalacija i održavanje",
    description: "Kompletna usluga — od projektovanja i instalacije do redovnog održavanja i 3 godine garancije.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Konkurentne cene",
    description: "Nudimo premium opremu po konkurentnim cenama uz fleksibilne modele plaćanja za poslovne korisnike.",
  },
];